import { render, staticRenderFns } from "./VIconEdit.vue?vue&type=template&id=27b8bb42&"
import script from "./VIconEdit.vue?vue&type=script&lang=ts&"
export * from "./VIconEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports